import React from 'react';
import {StyleSheet, View} from 'react-native';

import Text from '../../../components/ui-controls/Text';
import theme from '../../../style/theme';

export interface EmptyCartProps {
  isWebDesktopScreen?: boolean;
}

/**
 * Empty cart display component showing "no products found" message.
 * Extracted to its own file to avoid circular dependencies.
 */
export function EmptyCart({isWebDesktopScreen}: EmptyCartProps) {
  return (
    <View
      style={[styles.centerNotice, isWebDesktopScreen ? {marginTop: '25%'} : {}]}
      testID="cart-screen-empty-cart">
      <Text style={[styles.largeNotice, {marginBottom: 16}]}>NO PRODUCTS FOUND</Text>
      <Text style={styles.italicText}>There doesn&apos;t appear to be any</Text>
      <Text style={styles.italicText}>products in your shopping cart.</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  centerNotice: {
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    marginTop: '50%',
  },
  largeNotice: {
    fontSize: 16,
    fontWeight: '500',
    color: theme.colour.text.heading.primary,
  },
  italicText: {
    fontSize: 16,
    fontWeight: '300',
    color: theme.colour.text.heading.primary,
    textAlign: 'center',
    fontStyle: 'italic',
  },
});

export default EmptyCart;
